import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "requirements", "rule"]

  connect() {
    this.isEditing = false
    this.requirementsTarget.classList.remove("show")
  }

  startEditing() {
    this.isEditing = true
  }

  validate() {
    if (!this.isEditing) return

    const password = this.inputTarget.value

    this.requirementsTarget.classList.add("show")
    this.ruleTargets.forEach((rule) => {
      if (password.length === 0) {
        this.setNeutral(rule)
      } else {
        this.setValidity(rule, this.isValid(rule.dataset.passwordValidationRule, password))
      }
    })
  }

  isValid(rule, password) {
    switch (rule) {
      case "length":
        return password.length >= 8
      case "case":
        return /[A-Z]/.test(password) && /[a-z]/.test(password)
      case "number":
        return /\d/.test(password)
      case "special-character":
        return /[$£€@!%*?~+=§&#()[\]{}<>.\-_,;:^`'\\]/.test(password)
      default:
        return false
    }
  }

  setValidity(rule, valid) {
    rule.classList.toggle("valid", valid)
    rule.classList.toggle("invalid", !valid)
    rule.querySelector(".check").hidden = !valid
    rule.querySelector(".times").hidden = valid
    rule.querySelector(".circle").hidden = true
  }

  setNeutral(rule) {
    rule.classList.remove("valid", "invalid")
    rule.querySelector(".check").hidden = true
    rule.querySelector(".times").hidden = true
    rule.querySelector(".circle").hidden = false
  }
}
